// extracted by mini-css-extract-plugin
export default {"wrapper":"ConfigurableTanstackTable_wrapper__bSk79","table":"ConfigurableTanstackTable_table__kRqme","emptyContainer":"ConfigurableTanstackTable_emptyContainer__32yeV"};